export interface RouteData {
	hideHeader: boolean;
	hideFooter: boolean;
	title: string;
	name: string;
	breadcrumbs: string;
}

export interface QueryParamsTable {
	status?: string; // Status of table [OPEN, ORDER_PRINTED, BILL_PRINTED, ORDER_SAVED, ORDER_WAITING, ORDER_SPLIT]
	// floor?: number; // Floor section [Floor 1, Floor 2]
	type?: string; // Action [dine-in, take-out, vip, split-table]
	table: string | number; // Table info [floorid-tableid]
	tableAlias?: string; // Table info [floorid-tableid]
	guest?: number; // Number of guest
	split?: boolean; // Is split or no
	menuGroupId?: number; // id of group/sub-group/item
	categoryId?: number;
	groupParentId?: number;
	parentModifierGroupId?: number;
	itemId?: number;
	ticketId?: number;
	menuModifierGroupId?: number;
	isLock?: boolean;
}

export class QueryParamsUrls {
	split: boolean = false;
	type: string = null;
	table: string = null;
	tableAlias: string = null;
	itemId: number = null;
	ticketId: number = null;
	categoryId: number = null;
	menuGroupId: number = null;
	groupParentId: number = null;
	menuModifierGroupId: number = null;
	parentModifierGroupId: number = null;
	isLock?: boolean;
}
